import React from "react";
import DialogSearch from "../DialogSearch";
import TileOrderStatusReason from "../../Tile/TileOrderStatusReason";
import PropTypes from "prop-types";
import OrderStatusReason from "../../../Utility/Crud/OrderStatusReason";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchOrderStatusReason extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for Order Activity Types by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered orderStatusReasons.
     */
    getSearchResults(query) {
        return OrderStatusReason.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.orderStatusReasonsIndexed);
        }
    }

    /**
     * @param {object} orderStatusReason The orderStatusReason object.
     * @returns A TileOrderStatusReason component for this orderStatusReason.
     */
    renderTile(orderStatusReason) {
        return (
            <TileOrderStatusReason
                key={orderStatusReason.id}
                orderStatusReason={orderStatusReason}
            />
        );
    }

    /**
     * @returns {number} Infinity - show them all.
     */
    getMaxResults() {
        return Infinity;
    }

}
